export default __webpack_public_path__ + "static/media/euro2024_title.2c51719d.svg";